module.exports = __webpack_public_path__ + "static/media/tk.8f22420c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tk.png
// module id = 1998
// module chunks = 0